/* =============================================
   JARDIM SECRETO & Co. — theme.js
   Adaptado de main.js para a Shopify:
   o carrinho agora usa a Ajax Cart API nativa
   (/cart/add.js, /cart/change.js, /cart.js)
   em vez de localStorage.
   ============================================= */
(function () {
  'use strict';

  /* --- LOADING SCREEN --- */
  window.addEventListener('load', () => {
    setTimeout(() => {
      document.getElementById('page-loader')?.classList.add('hidden');
    }, 600);
  });

  /* --- HEADER STICKY --- */
  const header = document.querySelector('.header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* --- MENU MOBILE --- */
  const hamburger     = document.querySelector('.hamburger');
  const mobileMenu    = document.querySelector('.mobile-menu');
  const mobileOverlay = document.querySelector('.mobile-overlay');
  const menuClose     = document.querySelector('.mobile-menu__close');

  const openMenu  = () => { hamburger?.classList.add('open'); mobileMenu?.classList.add('open'); mobileOverlay?.classList.add('open'); document.body.style.overflow='hidden'; };
  const closeMenu = () => { hamburger?.classList.remove('open'); mobileMenu?.classList.remove('open'); mobileOverlay?.classList.remove('open'); document.body.style.overflow=''; };

  hamburger?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  mobileOverlay?.addEventListener('click', closeMenu);
  document.querySelectorAll('.mobile-menu__link').forEach(l => l.addEventListener('click', closeMenu));

  /* --- TOAST --- */
  function showToast(html) {
    const t = document.createElement('div'); t.className = 'toast'; t.innerHTML = html;
    document.body.appendChild(t);
    requestAnimationFrame(() => requestAnimationFrame(() => t.classList.add('toast--show')));
    setTimeout(() => { t.classList.remove('toast--show'); setTimeout(() => t.remove(), 400); }, 3200);
  }
  window.showToast = showToast;

  /* =============================================
     CARRINHO — Shopify Ajax Cart API
     ============================================= */
  function updateCartBadge() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-badge').forEach(b => {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(() => {});
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(r => {
      if (!r.ok) return r.json().then(err => { throw err; });
      return r.json();
    });
  }

  /* Botões de card de produto [data-add-cart] */
  document.querySelectorAll('[data-add-cart]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      if (btn.disabled) return;
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      const orig = btn.textContent.trim();
      btn.disabled = true; btn.textContent = 'Adicionando...';
      addToCart(variantId, 1)
        .then(() => {
          updateCartBadge();
          showToast(`<i class="fa-solid fa-check"></i> <strong>${btn.dataset.name || 'Produto'}</strong> adicionado!`);
          btn.textContent = '✓ Adicionado'; btn.classList.add('js-added');
          setTimeout(() => { btn.textContent = orig; btn.classList.remove('js-added'); btn.disabled = false; }, 2500);
        })
        .catch(err => {
          showToast(`<i class="fa-solid fa-triangle-exclamation"></i> ${err.description || 'Não foi possível adicionar ao carrinho.'}`);
          btn.textContent = orig; btn.disabled = false;
        });
    });
  });

  /* Página de produto — formulário com variantes */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    const variantInput = document.getElementById('product-variant-id');
    const variantsDataEl = document.querySelector('[data-product-variants]');
    const variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
    const optionSelects = productForm.querySelectorAll('.product-option-select');

    function findMatchingVariant() {
      if (!optionSelects.length) return null;
      const selected = Array.from(optionSelects).map(s => s.value);
      return variants.find(v => v.options.every((val, i) => val === selected[i]));
    }

    optionSelects.forEach(sel => {
      sel.addEventListener('change', () => {
        const match = findMatchingVariant();
        if (match && variantInput) {
          variantInput.value = match.id;
          const addBtn = document.getElementById('btn-add-product');
          const buyBtn = document.getElementById('btn-buy-now');
          [addBtn, buyBtn].forEach(b => { if (b) b.disabled = !match.available; });
        }
      });
    });

    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const addBtn = document.getElementById('btn-add-product');
      const qty = parseInt(productForm.querySelector('input[name="quantity"]')?.value || '1');
      const variantId = variantInput ? variantInput.value : null;
      if (!variantId) { productForm.submit(); return; }
      addBtn.disabled = true;
      addToCart(variantId, qty)
        .then(() => {
          updateCartBadge();
          showToast('<i class="fa-solid fa-check"></i> Produto adicionado ao carrinho!');
          addBtn.disabled = false;
        })
        .catch(err => {
          showToast(`<i class="fa-solid fa-triangle-exclamation"></i> ${err.description || 'Não foi possível adicionar ao carrinho.'}`);
          addBtn.disabled = false;
        });
    });

    document.getElementById('btn-buy-now')?.addEventListener('click', () => {
      const qty = parseInt(productForm.querySelector('input[name="quantity"]')?.value || '1');
      const variantId = variantInput ? variantInput.value : null;
      if (!variantId) return;
      addToCart(variantId, qty).then(() => { if (typeof yampiClick === 'function') { yampiClick(); } else { window.location.href = '/checkout'; } });
    });
  }

  /* Carrinho — quantidade +/- (Ajax) e remoção (link nativo já funciona sem JS) */
  document.querySelectorAll('.cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('.cart-qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      val = btn.dataset.action === 'plus' ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      const key = input.name.match(/\[(.*)\]/)[1];
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: val })
      }).then(() => window.location.reload());
    });
  });

  /* --- QUANTIDADE (produto) --- */
  document.querySelectorAll('.qty-control .qty-btn:not(.cart-qty-btn)').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-control')?.querySelector('.qty-num');
      if (!input) return;
      const cur = parseInt(input.value) || 1;
      input.value = btn.dataset.action === 'plus' ? cur + 1 : Math.max(1, cur - 1);
    });
  });

  /* --- GALERIA DO PRODUTO --- */
  document.querySelectorAll('.product-thumb').forEach(t => {
    t.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const full = t.dataset.full;
      const mainImg = document.getElementById('img-main');
      if (full && mainImg) mainImg.src = full;
    });
  });

  /* --- ABAS DO PRODUTO --- */
  document.querySelectorAll('.ptab-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const tab = btn.dataset.ptab;
      document.querySelectorAll('.ptab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.product-tab-content').forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      document.querySelector(`[data-ptab-content="${tab}"]`)?.classList.add('active');
    });
  });

  /* --- SCROLL ANIMATIONS --- */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('visible'); observer.unobserve(entry.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.aos, .aos-left, .aos-right, .aos-scale').forEach(el => observer.observe(el));

  /* --- PÉTALAS (hero) --- */
  const petalContainer = document.querySelector('.hero__petals');
  if (petalContainer) {
    const emojis = ['🌸','🌿','✿','❀','🌺','🍃'];
    for (let i = 0; i < 12; i++) {
      const p = document.createElement('span');
      p.className = 'petal';
      p.textContent = emojis[i % emojis.length];
      p.style.cssText = `left:${Math.random()*100}%;font-size:${10+Math.random()*14}px;animation-duration:${8+Math.random()*12}s;animation-delay:${Math.random()*10}s;opacity:0`;
      petalContainer.appendChild(p);
    }
  }

  /* --- CONTADORES --- */
  document.querySelectorAll('[data-count]').forEach(el => {
    const obs2 = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const target = parseInt(el.dataset.count);
        let current = 0;
        const step = target / 50;
        const timer = setInterval(() => {
          current = Math.min(current + step, target);
          el.textContent = Math.floor(current) + (el.dataset.suffix || '');
          if (current >= target) clearInterval(timer);
        }, 40);
        obs2.unobserve(el);
      });
    }, { threshold: 0.5 });
    obs2.observe(el);
  });

  updateCartBadge();
})();
